module.exports = __webpack_public_path__ + "img/epal.c0eba691.png";